module.exports = __webpack_public_path__ + "img/choose_your_product_v2.247b3395.svg";